export interface ICircularProgressBarProps {
  children?: any;
  className?: any;
  valuePercent: number;
  minValue?: number;
  maxValue?: number;
  strokeWidth?: number;
  color?: IPathColorTypes;
}

export enum IPathColorTypes {
  PRIMARY = 'pathPrimaryColor',
  SUCCESS = 'pathSuccessColor',
  DANGER = 'pathDangerColor',

  COLORS_WHITE = 'pathWhiteColor',
  NEUTRAL_MID_2 = 'pathMid2',
}
